import React from 'react';
import { IconsDictionary } from '@/components/icon/Icon.types';
import { CookieHelper } from '@/helpers/CookieHelper';
import VersionStatusPanelStyled from './VersionStatusPanel.styled';
import Dropdown from '@/components/dropdown/Dropdown';
import { PanelTypes } from '@/types/Panel.types';
import useReadLocalStorage from '@/hooks/useReadLocalStorage';

interface VersionStatusPanelProps {
  onClose: () => void;
}

const VersionStatusPanel = ({ onClose }: VersionStatusPanelProps) => {
  const cName = 'x-entry-versionstatus';
  const iniValue = window.ContensisEntryVersionStatus;
  const defaultValue = CookieHelper.GetCookie(cName) || iniValue;
  const position = useReadLocalStorage(
    'contensis-blocks-preview-toolbar-position'
  );

  const doUpdateVersionStatus = (evtValue: string) => {
    if (evtValue !== window.ContensisEntryVersionStatus) {
      CookieHelper.SetCookie(cName, evtValue);
      location?.reload();
    } else {
      CookieHelper.DeleteCookie(cName);
      location?.reload();
    }
  };

  return (
    <VersionStatusPanelStyled data-position={position}>
      <Dropdown
        id={PanelTypes.VersionStatus}
        defaultValue={defaultValue}
        onClose={onClose}
        onDropdownSelect={(evtValue: string) => doUpdateVersionStatus(evtValue)}
        options={[
          {
            icon: IconsDictionary.ListEdit,
            id: 'latest',
            label: 'Preview latest content',
          },
          {
            icon: IconsDictionary.ListCheck,
            id: 'published',
            label: 'Preview published content',
          },
        ]}
      />
    </VersionStatusPanelStyled>
  );
};

export default VersionStatusPanel;
